<template>
  <v-select
    v-model="selectedOptionValue"
    :items="modelList"
    :menu-props="{ maxHeight: '400' }"
    label="Состояние"
    item-value="id"
    item-text="title"
    multiple
    persistent-hint
    @change="onVacancyStateStateChange"
  />
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: 'WBDVacancyStateSelectorFilter',
  props: {
    label: {
      type: String,
      default: 'Состояние'
    },
    remoteOptionValue: {
      type: String,
    },
    remoteList: {
      type: Array,
    },
  },
  data () {
    return {
      loading: false,
      clearEvent: 'clearEvent',
      searchQuery: null,
      selectedOptionValue: null,
      onChangeEvent: 'onVacancyStateStateChange',
      modelList: [
        {
          id: 'certification',
          title: 'Имеет обучение',
        },
        {
          id: 'questions',
          title: 'Имеет вопросы',
        },
        {
          id: 'manual-payments',
          title: 'ручное согласование',
        },
        {
          id: 'required-medical-book',
          title: 'Требует ЛМК',
        },
        {
          id: 'worker-self-employed',
          title: 'Только СМЗ',
        },
        {
          id: 'worker-legal-person',
          title: 'Только ФИЗ',
        },
        {
          id: 'worker-all',
          title: 'Для Всех',
        },
        {
          id: 'worker-remote',
          title: 'Для своих',
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
    }),
    getModelList () {
      return this.modelList
    },
  },
  created () {
    if (this.remoteOptionValue) {
      this.selectedOptionValue = this.remoteOptionValue
    }
  },
  methods: {
    ...mapMutations({
    }),
    ...mapActions({
    }),
    onVacancyStateStateChange (data) {
      console.log(data)
      this.$emit(
        this.onChangeEvent,
        data
      )
    },
    onClear () {
      this.selectedOptionValue = null
      this.searchQuery = null
    },
  }
}
</script>
